import React from 'react';
import { Edit } from 'react-admin';

import RouteForm from '../RouteForm';

function RouteEdit(props) {
    return (
        <Edit {...props}>
            <RouteForm />
        </Edit>
    );
}

export default RouteEdit;
